export default __webpack_public_path__ + "static/media/Home-foto-header-incoming-Tower-viajes-mobile@2x.08f9c36e.jpg";